export const MAX_STEPS = 3;